import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../../../services/local-storage';
import { LoaderService } from '../../../services/Spinner.service';
import { SharedService } from '../../../services/shared.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupSegmentComponent } from '../../shared/components/popupAdmin/popup-segment.component';
import { Router } from '@angular/router';
import { IMyDpOptions, IMyDate ,IMyDateModel} from 'mydatepicker';
import { Data } from "./data";


@Component({
    selector: 'app-couponcode',
    templateUrl: './createcouponcode.component.html',
  providers: [ SharedService,PopupSegmentComponent]
 
})
export class CreateCouponCodeComponent implements OnInit {

data = [];
imageDta: any;
companiesSelected =[];
  imageData: any=[];
coupon:any;
errorMsgAudience ="";
    data1: any;
    CrtCouponCodeForm:FormGroup;
    loaderFlag : boolean;
    objLoaderStatus: boolean = false;
     name = "";
    description ="";
    selectedAud : any;
    dicount : number;
    id : number;
    couponStartDate : any;
    companyFlag : boolean;
user = [];
companies =[];
errorMsgCoupon ="";
allFlag : boolean = true;
disableCreate :boolean = false;
startDateFlag : boolean = false;
     myDatePickerOptions: IMyDpOptions = {
        // other options...
        dateFormat: 'dd/mm/yyyy',
        alignSelectorRight: true,
        showTodayBtn: false,
        disableUntil: {
            year: 2017,
            month: 7,
            day: 17
        },
    };

       myDatePickerOptionsend: IMyDpOptions = {
        // other options...
        dateFormat: 'dd/mm/yyyy',
        alignSelectorRight: true,
        showTodayBtn: false,
        disableUntil: {
            year: 2017,
            month: 7,
            day: 17
        },
    };
    constructor(private localstorage: LocalStorage,
     private loaderService: LoaderService,
    private formBuilder: FormBuilder,
    private shareService: SharedService,private router: Router,
     private dialogService:DialogService,private dataCompanies: Data) {
  

this.coupon = 
        {
  "branchesAllowed": [
  ],
  "code": "",
  "companies": [
  ],
  "description": "",
  "discountType": "PERCENTAGE",
  "discountValue": null,
  "endDate": "",
  "maxDiscount": null,
  "maxUsageAllowed": null,
  "startDate": "",
  "status": "ACTIVE",
  "successMessage": "",
  "tnc": "",
"startDateFlag" : false
    }  
 
this.CrtCouponCodeForm = this.formBuilder.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      discount: ['', Validators.required],
      maxDiscount : ['', Validators.required],
       couponStartDate: ['', Validators.required],
       couponEndDate : ['',Validators.required],
       maxUsageAllowed : ['', Validators.required],
       companies :['']
    });
  }

    ngOnInit() {
var x= document.getElementById('id1');
       x.classList.toggle("submenuActive"); 
this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });

    if(this.dataCompanies.storage && this.dataCompanies.storage.coupon){
                   this.coupon = this.dataCompanies.storage.coupon;
 }
 if(this.dataCompanies.storage && this.dataCompanies.storage.companies){
        this.companies = this.dataCompanies.storage.companies;
         if(this.companies == [0]){
            this.companies= [];
        }
       }

        if(this.dataCompanies.storage && this.dataCompanies.storage.branches){
        this.coupon.branchesAllowed = this.dataCompanies.storage.branches;
        if(this.coupon.branchesAllowed == [0]){
            this.coupon.branchesAllowed = [];
        }
       }

        if(this.dataCompanies.storage && this.dataCompanies.storage.flag){
        this.companyFlag = this.dataCompanies.storage.flag;
       }

        if(this.dataCompanies.storage && this.dataCompanies.storage.selected){
        this.user = this.dataCompanies.storage.selected;
       }


 if(this.dataCompanies.storage && this.dataCompanies.storage.companiesSelected){
this.companiesSelected = this.dataCompanies.storage.companiesSelected;
 }

if(this.dataCompanies.storage && this.dataCompanies.storage.radioselected == false){
this.allFlag = this.dataCompanies.storage.radioselected;
 }
 if(this.allFlag == false){
        this.selectedAud = "select";
 
 }
else{
    this.selectedAud = "all";
}
       this.disbaledPreviousDate();
      

  }
 convert(str) {
        var date = new Date(str),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
        return [date.getFullYear(), mnth, day].join("-");
    }

    onlyNumberKey(event) {

    var flag = (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
return flag;
}

targetAudience(text){
    console.log("111"+text);
    if(text == "select"){
        this.allFlag = false;
    this.dataCompanies.storage = {
    "coupon": this.coupon,
    "companies":this.coupon.companies,
    "branches": this.coupon.branchesAllowed,
    "radioselected": this.allFlag
  }
       this.router.navigate(['/admin/couponCodes/audience']);

    }
    else if(text == "all"){
this.allFlag = true;
this.coupon.branchesAllowed = [0];
this.coupon.companies = [0];
    console.log(this.coupon.branchesAllowed);
    console.log(this.coupon.companies)

    }
    
}

checkValue(){
    console.log(this.coupon.discountValue);
    if(this.coupon.discountValue >100){
        this.errorMsgCoupon = "Discount Percentage can have maximum value as 100";

    }
      setTimeout(() => {
              this.errorMsgCoupon="";
          }, 2000);
}
  disbaledPreviousDate() {
        let date = new Date();
        let copy = this.getCopyOfOptions();
        copy.disableUntil = {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate() - 1
        };
        this.myDatePickerOptions = copy;
    }

 disbaledPreviousEndDate(event) {
     console.log(event);
     let date = event.jsdate;
    this.coupon.startDateFlag = true;
        let copy = this.getCopyOfOptions();
        copy.disableUntil = {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate() - 1
        };
        this.myDatePickerOptionsend = copy;
    }

 

 getCopyOfOptions() {
        return JSON.parse(JSON.stringify(this.myDatePickerOptions));
    }

  

createData(){
    this.errorMsgCoupon ="";
     var token = this.localstorage.getStorage("token");
   this.disableCreate = false;
var i=0;
console.log(this.coupon.endDate);

            if(this.allFlag == false){
                this.coupon.companies = this.companies;
                for(i=0;i<this.companiesSelected.length;i++){
                this.coupon.companies.push(this.companiesSelected[i]);
            }
        }
        else{
            this.coupon.companiesSelected  = [0];
        }

        if(this.allFlag == false){
    this.coupon.branchesAllowed = this.coupon.branchesAllowed.filter(function(elem, index, self) {
    return index == self.indexOf(elem);
})}
else{
    this.coupon.branchesAllowed = [0];
}


  this.coupon.companies = this.coupon.companies.filter(function(elem, index, self) {
    return index == self.indexOf(elem);
})

if(this.coupon.startDate.jsdate){
            this.coupon.startDate = this.convert(this.coupon.startDate.jsdate.toDateString()) + "T00:00:01.000Z";
}
else{
    this.coupon.startDate = this.coupon.startDate;
}
if(this.coupon.endDate.jsdate){
     this.coupon.endDate = this.convert(this.coupon.endDate.jsdate.toDateString()) + "T23:59:59.000Z";
}
else{
    this.coupon.endDate = this.coupon.endDate;
}
console.log(this.coupon.branchesAllowed);
console.log(this.coupon.companies);


             const isAllZero = !this.coupon.branchesAllowed.some(el => el !== 0);
             const isAllZeroCom = !this.coupon.companies.some(el => el !== 0);

this.coupon.maxDiscount = Number.parseInt(this.coupon.maxDiscount);
this.coupon.discountValue = Number.parseInt(this.coupon.discountValue);
this.coupon.maxUsageAllowed = Number.parseInt(this.coupon.maxUsageAllowed);

if(this.coupon.discountValue <= 100 && (isAllZero == false || isAllZeroCom == false || this.allFlag == true) ){

if(this.coupon.branchesAllowed.length ==0){
this.coupon.branchesAllowed = [0];
}

if(this.coupon.companies.length ==0){
this.coupon.companies = [0];
}


                   this.loaderService.displayLoader(true);
console.log(this.coupon);
if(this.allFlag == true){
       this.shareService.callApiWithToken("admin/coupon?allAdvertiserFlag=1", this.coupon, token).subscribe((result) => {
  console.log(result.data);
   if(result.data){
   this.showCreate();
    
   }
   else{
      this.showCreateAlready()
   }
                 this.loaderService.displayLoader(false);

         });
}
else{
          this.shareService.callApiWithToken("admin/coupon", this.coupon, token).subscribe((result) => {
   console.log(result.data);
   if(result.data){
   this.showCreate();
    
   }
   else{
      this.showCreateAlready()
   }
                 this.loaderService.displayLoader(false);

         });
}
  
}
else{
    if(this.coupon.discountValue > 100){
this.errorMsgCoupon = "Discount Percentage can have maximum value as 100";
    }
    if(isAllZeroCom || isAllZeroCom ){
       this.errorMsgAudience = "Select at least one company with branches in it";
    }
      setTimeout(() => {
              this.errorMsgCoupon="";
              this.errorMsgAudience="";
          }, 3000);
}
}

showCreate() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Coupon Information', 
                message:"Coupon Created Successfully",
              data: [],
            showcancel : false})
                .subscribe((isConfirmed)=>{
                 this.router.navigate(['admin/couponCodes']); 
                    if(this.companyFlag == true){
                        var i=0;
                       for(i=0;i<this.user.length;i++){
                       this.coupon.companies.push(this.user[i].id);
                       }
                   } 
                 this.dataCompanies.storage = {};

                });
        }

        showCreateAlready() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Coupon Information', 
                message:"Coupon Code Already Exists",
              data: [],
            showcancel : false})
                .subscribe((isConfirmed)=>{
                   console.log(this.coupon);
                 
                });
        }

}



// WEBPACK FOOTER //
// ./src/app/admin/layout/couponCode/createcouponcode.component.ts